var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/setManagementConnect/setManagementConnect.ts";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import { createCache } from '../cacheService';
import { AssemblyClassifier, DependencyWithModels, DynamicGroup, ElementPathClassifier, GetBaseClassifierVersionDiff, GetAssemblyClassifierVersionDiff, GetSourceClassifiersVersions, GetUserClassifierMigrationConflicts, InclusionStatus, Migrate, UserClassifier, UserClassifierGroup, UserClassifierRepo, UserClassifierRepoFolder, UserClassifierTree } from '../UserClassifierRepo';
import { BimReference } from '../BimReference';
import { BaseClassifier } from '../BaseClassifierRepo';
import { GetAllReferences } from '../ForgeViewerRepo';
import { UserClassifierPriorityOrder } from '../UserClassifierRepo/UserClassifierPriorityOrder';
export var elementPropertiesCache = createCache();
export var standardSizePropertiesCache = createCache();
export function setManagementConnect(setManagement) {
  UserClassifier.fetchIsUserClassifierLocked.use(function (_ref) {
    var id = _ref.id;
    return setManagement.get("/v1/classifier-repo/base-classifier/".concat(id, "/lock")).then(UserClassifier.fetchIsUserClassifierLocked.toPromise);
  });
  UserClassifier.fetch.use(function (_ref2) {
    var id = _ref2.id,
        version = _ref2.version;
    return setManagement.get("/v1/classifier-repo/user-classifier/".concat(id, "/version/").concat(version)).then(UserClassifier.fetch.toPromise);
  });
  UserClassifier.fetch.use(function (_ref3) {
    var id = _ref3.id,
        version = _ref3.version;
    return setManagement.get("/v1/classifier-repo/user-classifier/".concat(id, "/version/").concat(version)).then(UserClassifier.fetch.toPromise);
  });
  UserClassifier.getMostRecent.use(function (_ref4) {
    var id = _ref4.id;
    return setManagement.get("/v1/classifier-repo/user-classifier/".concat(id, "/most-recent")).then(UserClassifier.getMostRecent.toPromise);
  });
  UserClassifier.getMostRecentSilent.use(function (_ref5) {
    var id = _ref5.id;
    return setManagement.get("/v1/classifier-repo/user-classifier/".concat(id, "/most-recent")).then(UserClassifier.getMostRecentSilent.toPromise);
  });
  DependencyWithModels.getClassifierDependencyModels.use(function (_ref6) {
    var id = _ref6.id,
        version = _ref6.version;
    return setManagement.get("/v1/classifier-repo/user-classifier/".concat(id, "/version/").concat(version, "/dependency-models")).then(DependencyWithModels.getClassifierDependencyModels.toPromise);
  });
  ElementPathClassifier.getElementPath.use(function (_ref7) {
    var id = _ref7.id,
        version = _ref7.version,
        elementId = _ref7.elementId,
        elementType = _ref7.elementType;
    return setManagement.get("/v1/classifier-repo/user-classifier/".concat(id, "/version/").concat(version, "/element-path?element-id=").concat(elementId, "&element-type=").concat(elementType)).then(ElementPathClassifier.getElementPath.toPromise);
  });
  UserClassifier.addDependency.use(function (_ref8) {
    var id = _ref8.id,
        sourceClassifierId = _ref8.sourceClassifierId,
        version = _ref8.version,
        sourceClassifierVersion = _ref8.sourceClassifierVersion;
    return setManagement.post("/v1/classifier-repo/user-classifier/".concat(id, "/version/").concat(version, "/source-classifier"), {
      sourceClassifierId: sourceClassifierId,
      sourceClassifierVersion: sourceClassifierVersion
    }).then(UserClassifier.addDependency.toPromise);
  });
  UserClassifier.create.use(function (_ref9) {
    var name = _ref9.name,
        parentFolderId = _ref9.parentFolderId,
        projectUrn = _ref9.projectUrn;
    return setManagement.post("/v1/classifier-repo/user-classifier/project/".concat(projectUrn), {
      name: name,
      parentFolderId: parentFolderId
    }).then(UserClassifier.create.toPromise);
  });
  UserClassifier.copy.use(function (_ref10) {
    var id = _ref10.id,
        version = _ref10.version,
        name = _ref10.name;
    return setManagement.post("/v1/classifier-repo/user-classifier/".concat(id, "/version/").concat(version, "/copy"), {
      name: name
    }).then(UserClassifier.create.toPromise);
  });
  UserClassifierGroup.groupCopying.use(function (_ref11) {
    var classifierId = _ref11.classifierId,
        classifierVersion = _ref11.classifierVersion,
        parentGroupId = _ref11.parentGroupId,
        sourceGroupId = _ref11.sourceGroupId;
    return setManagement.post("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/group/copy"), {
      parentGroupId: parentGroupId,
      sourceGroupId: sourceGroupId
    }).then(UserClassifierGroup.groupCopying.toPromise);
  });
  UserClassifier.rename.use(function (_ref12) {
    var id = _ref12.id,
        name = _ref12.name,
        parentFolderId = _ref12.parentFolderId,
        version = _ref12.version;
    return setManagement.patch("/v1/classifier-repo/user-classifier/".concat(id, "/version/").concat(version), {
      name: name,
      parentFolderId: parentFolderId
    }).then(UserClassifier.rename.toPromise);
  });
  UserClassifier.move.use(function (_ref13) {
    var id = _ref13.id,
        parentFolderId = _ref13.parentFolderId,
        version = _ref13.version;
    return setManagement.patch("/v1/classifier-repo/user-classifier/".concat(id, "/version/").concat(version), {
      parentFolderId: parentFolderId
    }).then(UserClassifier.move.toPromise);
  });
  UserClassifier.removeDependency.use(function (_ref14) {
    var id = _ref14.id,
        sourceClassifierId = _ref14.sourceClassifierId,
        version = _ref14.version;
    return setManagement["delete"]("/v1/classifier-repo/user-classifier/".concat(id, "/version/").concat(version, "/source-classifier/").concat(sourceClassifierId)).then(UserClassifier.removeDependency.toPromise);
  });
  UserClassifier.remove.use(function (_ref15) {
    var id = _ref15.id;
    return setManagement["delete"]("/v1/classifier-repo/user-classifier/".concat(id)).then(UserClassifier.remove.toPromise);
  });
  UserClassifier.removeAll.use(function (_ref16) {
    var id = _ref16.id,
        version = _ref16.version,
        items = _ref16.items;
    return setManagement.post("/v1/classifier-repo/user-classifier/".concat(id, "/version/").concat(version, "/delete-items"), {
      items: items
    }).then(UserClassifier.removeAll.toPromise);
  });
  UserClassifier.createRefsFromExternalIds.use(function (_ref17) {
    var items = _ref17.items,
        id = _ref17.id,
        version = _ref17.version,
        parentGroupId = _ref17.parentGroupId;
    return setManagement.post("/v1/classifier-repo/user-classifier/".concat(id, "/version/").concat(version, "/create-element-refs-by-forge-external-ids"), {
      parentGroupId: parentGroupId,
      items: items
    }).then(UserClassifier.createRefsFromExternalIds.toPromise);
  }); // UserClassifierRepositoryFolder CRUD operations

  UserClassifierRepoFolder.fetch.use(function (_ref18) {
    var id = _ref18.id;
    return setManagement.get("/v1/classifier-repo/user-classifier/folder/".concat(id)).then(UserClassifierRepoFolder.fetch.toPromise);
  });
  UserClassifierRepoFolder.fetchSilent.use(function (_ref19) {
    var id = _ref19.id;
    return setManagement.get("/v1/classifier-repo/user-classifier/folder/".concat(id), {
      skip403: true
    }).then(UserClassifierRepoFolder.fetchSilent.toPromise);
  });
  UserClassifierRepoFolder.create.use(function (_ref20) {
    var name = _ref20.name,
        parentFolderId = _ref20.parentFolderId,
        projectUrn = _ref20.projectUrn;
    return setManagement.post("/v1/classifier-repo/user-classifier/project/".concat(projectUrn, "/folder"), {
      name: name,
      parentFolderId: parentFolderId
    }).then(UserClassifierRepoFolder.create.toPromise);
  });
  UserClassifier.fetchFlatListDependencies.use(function (_ref21) {
    var classifierId = _ref21.classifierId,
        classifierVersion = _ref21.classifierVersion;
    return setManagement.get("/v2/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/flat-list-dependencies")).then(UserClassifier.fetchFlatListDependencies.toPromise);
  });
  UserClassifier.fetchFlatListItems.use(function (_ref22) {
    var classifierId = _ref22.classifierId,
        classifierVersion = _ref22.classifierVersion,
        skipRef = _ref22.skipRef;
    return setManagement.get("/v2/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/flat-list-items").concat(skipRef ? '?skip-ref=true' : '')).then(UserClassifier.fetchFlatListItems.toPromise);
  });
  UserClassifier.findElementEverywhere.use(function (_ref23) {
    var classifierId = _ref23.classifierId,
        classifierVersion = _ref23.classifierVersion,
        body = _objectWithoutProperties(_ref23, ["classifierId", "classifierVersion"]);

    return setManagement.post("/v2/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/find-element-everywhere"), body).then(UserClassifier.findElementEverywhere.toPromise);
  });
  UserClassifier.fetchDynamicGroupFlatItems.use(function (_ref24) {
    var classifierId = _ref24.classifierId,
        classifierVersion = _ref24.classifierVersion;
    return setManagement.get("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/dynamic-group-flat-list")).then(UserClassifier.fetchDynamicGroupFlatItems.toPromise);
  });
  UserClassifier.Property.List.fetchElementProperties.use(function (_ref25) {
    var classifierId = _ref25.classifierId,
        classifierVersion = _ref25.classifierVersion,
        sources = _ref25.sources;
    return setManagement.post("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/element-properties"), {
      sources: sources
    }).then(UserClassifier.Property.List.fetchElementProperties.toPromise);
  });
  UserClassifier.Property.List.fetchElementPropertyValues.use(function (_ref26) {
    var classifierId = _ref26.classifierId,
        classifierVersion = _ref26.classifierVersion,
        sources = _ref26.sources,
        propertyId = _ref26.propertyId;
    return setManagement.post("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/element-property-values"), {
      sources: sources,
      propertyId: propertyId
    }).then(UserClassifier.Property.List.fetchElementPropertyValues.toPromise);
  });
  UserClassifier.fetchElementRefs.use(function (_ref27) {
    var elementId = _ref27.elementId,
        classifiers = _ref27.classifiers;
    return setManagement.post("/v1/classifier-repo/user-classifier/element-refs", {
      elementId: elementId,
      classifiers: classifiers
    }).then(UserClassifier.fetchElementRefs.toPromise);
  });
  UserClassifier.findAllElementsByFilter.use(function (_ref28) {
    var classifierId = _ref28.classifierId,
        classifierVersion = _ref28.classifierVersion,
        filterCondition = _ref28.filterCondition;
    return setManagement.post("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/filter-group/find-all"), {
      filterCondition: filterCondition
    }).then(UserClassifier.findAllElementsByFilter.toPromise);
  });
  UserClassifierRepoFolder.rename.use(function (_ref29) {
    var id = _ref29.id,
        name = _ref29.name,
        parentFolderId = _ref29.parentFolderId;
    return setManagement.patch("/v1/classifier-repo/user-classifier/folder/".concat(id), {
      name: name,
      parentFolderId: parentFolderId
    }).then(UserClassifierRepoFolder.rename.toPromise);
  });
  UserClassifierRepoFolder.move.use(function (_ref30) {
    var id = _ref30.id,
        parentFolderId = _ref30.parentFolderId;
    return setManagement.patch("/v1/classifier-repo/user-classifier/folder/".concat(id), {
      parentFolderId: parentFolderId
    }).then(UserClassifierRepoFolder.move.toPromise);
  });
  UserClassifierRepoFolder.remove.use(function (_ref31) {
    var id = _ref31.id;
    return setManagement["delete"]("/v1/classifier-repo/user-classifier/folder/".concat(id)).then(UserClassifierRepoFolder.remove.toPromise);
  }); // UserClassifierGroup CRUD operations

  UserClassifierGroup.fetch.use(function (_ref32) {
    var classifierId = _ref32.classifierId,
        id = _ref32.id,
        parentClassifierVersion = _ref32.parentClassifierVersion,
        limit = _ref32.limit,
        offset = _ref32.offset;
    return setManagement.get("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(parentClassifierVersion, "/group/").concat(id, "?limit=").concat(limit, "&offset=").concat(offset)).then(UserClassifierGroup.fetch.toPromise);
  });
  UserClassifierGroup.Property.List.fetchElementProperties.use(function (_ref33) {
    var classifierId = _ref33.classifierId,
        classifierVersion = _ref33.classifierVersion,
        groupId = _ref33.groupId;
    return setManagement.get("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/group/").concat(groupId, "/model-element-properties")).then(UserClassifierGroup.Property.List.fetchElementProperties.toPromise);
  });
  UserClassifierGroup.Property.List.fetchStandardSizeProperties.use(function (_ref34) {
    var classifierId = _ref34.classifierId,
        classifierVersion = _ref34.classifierVersion,
        groupId = _ref34.groupId;
    return setManagement.get("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/group/").concat(groupId, "/model-standard-size-properties")).then(UserClassifierGroup.Property.List.fetchStandardSizeProperties.toPromise);
  });
  UserClassifierGroup.create.use(function (_ref35) {
    var name = _ref35.name,
        classifierId = _ref35.classifierId,
        parentGroupId = _ref35.parentGroupId,
        parentClassifierVersion = _ref35.parentClassifierVersion;
    return setManagement.post("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(parentClassifierVersion, "/group"), {
      name: name,
      parentGroupId: parentGroupId
    }).then(UserClassifierGroup.create.toPromise);
  });
  UserClassifierGroup.createGroupReference.use(function (_ref36) {
    var classifierId = _ref36.classifierId,
        parentClassifierVersion = _ref36.parentClassifierVersion,
        sourceClassifierId = _ref36.sourceClassifierId,
        sourceClassifierVersion = _ref36.sourceClassifierVersion,
        sourceGroupId = _ref36.sourceGroupId,
        parentGroupId = _ref36.parentGroupId;
    return setManagement.post("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(parentClassifierVersion, "/group-reference"), {
      sourceClassifierId: sourceClassifierId,
      sourceClassifierVersion: sourceClassifierVersion,
      sourceGroupId: sourceGroupId,
      parentGroupId: parentGroupId
    }).then(UserClassifierGroup.createGroupReference.toPromise);
  });
  UserClassifierGroup.rename.use(function (_ref37) {
    var classifierId = _ref37.classifierId,
        id = _ref37.id,
        name = _ref37.name,
        parentGroupId = _ref37.parentGroupId,
        parentClassifierVersion = _ref37.parentClassifierVersion;
    return setManagement.patch("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(parentClassifierVersion, "/group/").concat(id), {
      name: name,
      parentGroupId: parentGroupId
    }).then(UserClassifierGroup.rename.toPromise);
  });
  UserClassifierGroup.move.use(function (_ref38) {
    var id = _ref38.id,
        classifierId = _ref38.classifierId,
        parentGroupId = _ref38.parentGroupId,
        parentClassifierVersion = _ref38.parentClassifierVersion;
    return setManagement.patch("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(parentClassifierVersion, "/group/").concat(id), {
      parentGroupId: parentGroupId
    }).then(UserClassifierGroup.move.toPromise);
  });
  UserClassifierGroup.remove.use(function (_ref39) {
    var classifierId = _ref39.classifierId,
        id = _ref39.id,
        parentClassifierVersion = _ref39.parentClassifierVersion;
    return setManagement["delete"]("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(parentClassifierVersion, "/group/").concat(id)).then(UserClassifierGroup.remove.toPromise);
  }); // Reference CRUD operations

  BimReference.create.use(function (_ref40) {
    var parentGroupId = _ref40.groupId,
        classifierId = _ref40.classifierId,
        classifierVersion = _ref40.classifierVersion,
        sourceClassifierId = _ref40.sourceClassifierId,
        sourceClassifierVersion = _ref40.sourceClassifierVersion,
        sourceParentGroupId = _ref40.sourceParentGroupId,
        modelElementId = _ref40.modelElementId,
        modelElementType = _ref40.modelElementType;
    return setManagement.post("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/reference"), {
      parentGroupId: parentGroupId,
      sourceClassifierId: sourceClassifierId,
      sourceClassifierVersion: sourceClassifierVersion,
      sourceParentGroupId: sourceParentGroupId,
      modelElementId: modelElementId,
      modelElementType: modelElementType
    }).then(BimReference.create.toPromise);
  });
  BimReference.createRefs.use(function (_ref41) {
    var classifierId = _ref41.classifierId,
        classifierVersion = _ref41.classifierVersion,
        parentGroupId = _ref41.parentGroupId,
        items = _ref41.items;
    return setManagement.post("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/create-items"), {
      parentGroupId: parentGroupId,
      items: items
    }).then(BimReference.createRefs.toPromise);
  });
  BimReference.move.use(function (_ref42) {
    var id = _ref42.id,
        classifierId = _ref42.classifierId,
        classifierVersion = _ref42.classifierVersion,
        parentGroupId = _ref42.groupId;
    return setManagement.patch("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/reference/").concat(id), {
      parentGroupId: parentGroupId
    }).then(BimReference.move.toPromise);
  });
  BimReference.moveRefs.use(function (_ref43) {
    var id = _ref43.id,
        parentGroupId = _ref43.parentGroupId,
        version = _ref43.version,
        items = _ref43.items;
    return setManagement.patch("/v1/classifier-repo/user-classifier/".concat(id, "/version/").concat(version, "/update-items"), {
      parentGroupId: parentGroupId,
      items: items
    }).then(BimReference.moveRefs.toPromise);
  });
  BimReference.remove.use(function (_ref44) {
    var classifierId = _ref44.classifierId,
        classifierVersion = _ref44.classifierVersion,
        id = _ref44.id;
    return setManagement["delete"]("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/reference/").concat(id)).then(BimReference.remove.toPromise);
  }); // UserClassifierRepository

  UserClassifierRepo.fetch.use(function (_ref45) {
    var projectUrn = _ref45.projectUrn;
    return setManagement.get("/v1/classifier-repo/user-classifier/project/".concat(projectUrn)).then(UserClassifierRepo.fetch.toPromise);
  }); // BaseClassifier

  BaseClassifier.Populated.fetch.use(function (_ref46) {
    var id = _ref46.id,
        version = _ref46.version;
    return setManagement.get("/v1/classifier-repo/base-classifier/".concat(id, "/version/").concat(version)).then(BaseClassifier.Populated.fetch.toPromise);
  });
  InclusionStatus.calculate.use(function (_ref47) {
    var classifierId = _ref47.classifierId,
        classifierVersion = _ref47.classifierVersion;
    return setManagement.get("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/inclusion-status")).then(InclusionStatus.calculate.toPromise);
  });
  InclusionStatus.calculateStandardSize.use(function (_ref48) {
    var classifierId = _ref48.classifierId,
        classifierVersion = _ref48.classifierVersion,
        modelVersion = _ref48.modelVersion,
        standardSizeId = _ref48.standardSizeId;
    return setManagement.get("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/standard-size/").concat(standardSizeId, "/model-version/").concat(modelVersion, "/inclusion-status")).then(InclusionStatus.calculate.toPromise);
  });
  GetAllReferences.fetch.use(function (_ref49) {
    var groups = _ref49.groups;
    return setManagement.post("/v1/classifier-repo/user-classifier/group/get-all-references", {
      groups: groups
    }).then(GetAllReferences.fetch.toPromise);
  }); // migration

  GetSourceClassifiersVersions.use(function (_ref50) {
    var id = _ref50.id,
        version = _ref50.version;
    return setManagement.get("/v1/classifier-repo/user-classifier/".concat(id, "/version/").concat(version, "/versions-stat")).then(GetSourceClassifiersVersions.toPromise);
  });
  GetBaseClassifierVersionDiff.use(function (_ref51) {
    var id = _ref51.id,
        versionFrom = _ref51.versionFrom,
        versionTo = _ref51.versionTo;
    return setManagement.get("/v1/classifier-repo/base-classifier/".concat(id, "/diff?version-from=").concat(versionFrom, "&version-to=").concat(versionTo)).then(GetBaseClassifierVersionDiff.toPromise);
  });
  GetAssemblyClassifierVersionDiff.use(function (_ref52) {
    var id = _ref52.id,
        versionFrom = _ref52.versionFrom,
        versionTo = _ref52.versionTo;
    return setManagement.get("/v1/classifier-repo/assembly-classifier/".concat(id, "/diff?version-from=").concat(versionFrom, "&version-to=").concat(versionTo)).then(GetAssemblyClassifierVersionDiff.toPromise);
  });
  GetUserClassifierMigrationConflicts.use(function (_ref53) {
    var id = _ref53.id,
        version = _ref53.version,
        sourceClassifierId = _ref53.sourceClassifierId,
        versionFrom = _ref53.versionFrom,
        versionTo = _ref53.versionTo;
    return setManagement.get("/v1/classifier-repo/user-classifier/".concat(id, "/version/").concat(version, "/source-classifiers/").concat(sourceClassifierId, "/conflicts?version-from=").concat(versionFrom, "&version-to=").concat(versionTo)).then(GetUserClassifierMigrationConflicts.toPromise);
  });
  Migrate.use(function (_ref54) {
    var classifierId = _ref54.classifierId,
        classifierVersion = _ref54.classifierVersion,
        currentSourceClassifierVersion = _ref54.currentSourceClassifierVersion,
        newSourceClassifierVersion = _ref54.newSourceClassifierVersion,
        sourceClassifierId = _ref54.sourceClassifierId;
    return setManagement.post("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/migrate"), {
      currentSourceClassifierVersion: currentSourceClassifierVersion,
      newSourceClassifierVersion: newSourceClassifierVersion,
      sourceClassifierId: sourceClassifierId
    }).then(Migrate.toPromise);
  });
  DynamicGroup.fetch.use(function (_ref55) {
    var classifierId = _ref55.classifierId,
        version = _ref55.version,
        dynamicGroupId = _ref55.dynamicGroupId,
        limit = _ref55.limit,
        offset = _ref55.offset;
    return setManagement.get("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(version, "/dynamic-group/").concat(dynamicGroupId, "?limit=").concat(limit, "&offset=").concat(offset)).then(DynamicGroup.fetch.toPromise);
  });
  DynamicGroup.create.use(function (_ref56) {
    var sourceGroupId = _ref56.sourceGroupId,
        classifierId = _ref56.classifierId,
        version = _ref56.version,
        groupingConditions = _ref56.groupingConditions;
    return setManagement.post("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(version, "/dynamic-group"), {
      sourceGroupId: sourceGroupId,
      groupingConditions: groupingConditions
    }).then(DynamicGroup.create.toPromise);
  });
  DynamicGroup.remove.use(function (_ref57) {
    var classifierId = _ref57.classifierId,
        version = _ref57.version,
        sourceGroupId = _ref57.sourceGroupId;
    return setManagement["delete"]("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(version, "/dynamic-group/").concat(sourceGroupId)).then(DynamicGroup.remove.toPromise);
  });
  DynamicGroup.start.use(function (_ref58) {
    var classifierId = _ref58.classifierId,
        version = _ref58.version;
    return setManagement.post("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(version, "/dynamic-group/start"), {}).then(DynamicGroup.start.toPromise);
  });
  DynamicGroup.status.use(function (_ref59) {
    var classifierId = _ref59.classifierId,
        version = _ref59.version;
    return setManagement.get("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(version, "/dynamic-group/status")).then(DynamicGroup.status.toPromise);
  });
  UserClassifier.fetchVersionDates.use(function (_ref60) {
    var classifierId = _ref60.classifierId;
    return setManagement.get("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/date")).then(UserClassifier.fetchVersionDates.toPromise);
  });
  UserClassifier.fetchVersionByDate.use(function (_ref61) {
    var classifierId = _ref61.classifierId,
        versionDate = _ref61.versionDate;
    return setManagement.get("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/date/").concat(versionDate)).then(UserClassifier.fetchVersionByDate.toPromise);
  });
  UserClassifier.renameVersion.use(function (_ref62) {
    var classifierId = _ref62.classifierId,
        classifierVersion = _ref62.classifierVersion,
        versionName = _ref62.versionName;
    return setManagement.post("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/name"), {
      versionName: versionName
    }).then(UserClassifier.renameVersion.toPromise);
  });
  UserClassifier.removeVersionName.use(function (_ref63) {
    var classifierId = _ref63.classifierId,
        classifierVersion = _ref63.classifierVersion;
    return setManagement["delete"]("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/name")).then(UserClassifier.removeVersionName.toPromise);
  });
  UserClassifier.fetchNamedVersions.use(function (_ref64) {
    var classifierId = _ref64.classifierId;
    return setManagement.get("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/name")).then(UserClassifier.fetchNamedVersions.toPromise);
  });
  UserClassifier.findDynamicGroups.use(function (_ref65) {
    var classifierId = _ref65.classifierId,
        classifierVersion = _ref65.classifierVersion,
        modelId = _ref65.modelId,
        modelVersion = _ref65.modelVersion,
        elementId = _ref65.elementId;
    return setManagement.get("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/find-dynamic-groups?model-id=").concat(modelId, "&model-version=").concat(modelVersion, "&element-id=").concat(elementId)).then(UserClassifier.findDynamicGroups.toPromise);
  });
  UserClassifierTree.GroupItem.getList.use(function (_ref66) {
    var classifierId = _ref66.classifierId,
        classifierVersion = _ref66.classifierVersion;
    return setManagement.get("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/group-tree")).then(UserClassifierTree.GroupItem.getList.toPromise);
  });
  UserClassifierTree.DynamicGroupItem.getList.use(function (_ref67) {
    var classifierId = _ref67.classifierId,
        classifierVersion = _ref67.classifierVersion;
    return setManagement.get("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/dynamic-group/list")).then(UserClassifierTree.DynamicGroupItem.getList.toPromise);
  });
  UserClassifierPriorityOrder.GetAll.fetch.use(function (_ref68) {
    var classifierId = _ref68.classifierId,
        classifierVersion = _ref68.classifierVersion;
    return setManagement.post("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/priority-order/search"), {}).then(UserClassifierPriorityOrder.GetAll.fetch.toPromise);
  });
  UserClassifierPriorityOrder.Recalculate.submit.use(function (_ref69) {
    var classifierId = _ref69.classifierId,
        classifierVersion = _ref69.classifierVersion,
        entityId = _ref69.entityId,
        parentId = _ref69.parentId,
        parentRefId = _ref69.parentRefId,
        entityType = _ref69.entityType,
        nextEntityId = _ref69.nextEntityId,
        parentType = _ref69.parentType;
    return setManagement.put("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/priority-order/recalculation"), {
      entityId: entityId,
      parentId: parentId,
      parentRefId: parentRefId,
      entityType: entityType,
      nextEntityId: nextEntityId,
      parentType: parentType
    }).then(UserClassifierPriorityOrder.Recalculate.submit.toPromise);
  });
  AssemblyClassifier.fetch.use(function (_ref70) {
    var id = _ref70.id,
        version = _ref70.version;
    return setManagement.get("/v1/classifier-repo/assembly-classifier/".concat(id, "/version/").concat(version)).then(AssemblyClassifier.fetch.toPromise);
  });
  AssemblyClassifier.create.use(function (_ref71) {
    var name = _ref71.name,
        parentFolderId = _ref71.parentFolderId,
        projectUrn = _ref71.projectUrn;
    return setManagement.post("/v1/classifier-repo/assembly-classifier/project/".concat(projectUrn), {
      name: name,
      parentFolderId: parentFolderId
    }).then(AssemblyClassifier.create.toPromise);
  });
  AssemblyClassifier.rename.use(function (_ref72) {
    var id = _ref72.id,
        name = _ref72.name,
        parentFolderId = _ref72.parentFolderId,
        version = _ref72.version;
    return setManagement.patch("/v1/classifier-repo/assembly-classifier/".concat(id, "/version/").concat(version), {
      name: name,
      parentFolderId: parentFolderId
    }).then(AssemblyClassifier.rename.toPromise);
  });
  AssemblyClassifier.move.use(function (_ref73) {
    var id = _ref73.id,
        parentFolderId = _ref73.parentFolderId,
        version = _ref73.version;
    return setManagement.patch("/v1/classifier-repo/assembly-classifier/".concat(id, "/version/").concat(version), {
      parentFolderId: parentFolderId
    }).then(AssemblyClassifier.move.toPromise);
  });
  AssemblyClassifier.remove.use(function (_ref74) {
    var id = _ref74.id;
    return setManagement["delete"]("/v1/classifier-repo/assembly-classifier/".concat(id)).then(AssemblyClassifier.remove.toPromise);
  });
  AssemblyClassifier.copy.use(function (_ref75) {
    var id = _ref75.id,
        version = _ref75.version,
        name = _ref75.name;
    return setManagement.post("/v1/classifier-repo/assembly-classifier/".concat(id, "/version/").concat(version, "/copy"), {
      name: name
    }).then(AssemblyClassifier.copy.toPromise);
  });
  AssemblyClassifier.addDependency.use(function (_ref76) {
    var id = _ref76.id,
        sourceClassifierId = _ref76.sourceClassifierId,
        version = _ref76.version,
        sourceClassifierVersion = _ref76.sourceClassifierVersion;
    return setManagement.post("/v1/classifier-repo/assembly-classifier/".concat(id, "/version/").concat(version, "/source-classifier"), {
      sourceClassifierId: sourceClassifierId,
      sourceClassifierVersion: sourceClassifierVersion
    }).then(AssemblyClassifier.addDependency.toPromise);
  });
  AssemblyClassifier.removeDependency.use(function (_ref77) {
    var id = _ref77.id,
        sourceClassifierId = _ref77.sourceClassifierId,
        version = _ref77.version;
    return setManagement["delete"]("/v1/classifier-repo/assembly-classifier/".concat(id, "/version/").concat(version, "/source-classifier/").concat(sourceClassifierId)).then(AssemblyClassifier.removeDependency.toPromise);
  });
  AssemblyClassifier.fetchSourceModels.use(function (_ref78) {
    var id = _ref78.id,
        version = _ref78.version;
    return setManagement.get("/v1/classifier-repo/assembly-classifier/".concat(id, "/version/").concat(version, "/source-models")).then(AssemblyClassifier.fetchSourceModels.toPromise);
  });
  AssemblyClassifier.getMostRecent.use(function (_ref79) {
    var id = _ref79.id;
    return setManagement.get("/v1/classifier-repo/assembly-classifier/".concat(id, "/most-recent")).then(AssemblyClassifier.getMostRecent.toPromise);
  });
  AssemblyClassifier.getMostRecentSilent.use(function (_ref80) {
    var id = _ref80.id;
    return setManagement.get("/v1/classifier-repo/assembly-classifier/".concat(id, "/most-recent")).then(AssemblyClassifier.getMostRecentSilent.toPromise);
  });
  AssemblyClassifier.runAssembly.use(function (_ref81) {
    var id = _ref81.id,
        version = _ref81.version;
    return setManagement.get("/v1/classifier-repo/assembly-classifier/".concat(id, "/version/").concat(version, "/generate-assembly")).then(AssemblyClassifier.runAssembly.toPromise);
  });
  AssemblyClassifier.fetchVersionDates.use(function (_ref82) {
    var classifierId = _ref82.classifierId;
    return setManagement.get("/v1/classifier-repo/assembly-classifier/".concat(classifierId, "/version/date")).then(AssemblyClassifier.fetchVersionDates.toPromise);
  });
  AssemblyClassifier.fetchVersionByDate.use(function (_ref83) {
    var classifierId = _ref83.classifierId,
        versionDate = _ref83.versionDate;
    return setManagement.get("/v1/classifier-repo/assembly-classifier/".concat(classifierId, "/version/date/").concat(versionDate)).then(AssemblyClassifier.fetchVersionByDate.toPromise);
  });
  AssemblyClassifier.renameVersion.use(function (_ref84) {
    var classifierId = _ref84.classifierId,
        classifierVersion = _ref84.classifierVersion,
        versionName = _ref84.versionName;
    return setManagement.post("/v1/classifier-repo/assembly-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/name"), {
      versionName: versionName
    }).then(AssemblyClassifier.renameVersion.toPromise);
  });
  AssemblyClassifier.removeVersionName.use(function (_ref85) {
    var classifierId = _ref85.classifierId,
        classifierVersion = _ref85.classifierVersion;
    return setManagement["delete"]("/v1/classifier-repo/assembly-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/name")).then(AssemblyClassifier.removeVersionName.toPromise);
  });
  AssemblyClassifier.fetchNamedVersions.use(function (_ref86) {
    var classifierId = _ref86.classifierId;
    return setManagement.get("/v1/classifier-repo/assembly-classifier/".concat(classifierId, "/version/name")).then(AssemblyClassifier.fetchNamedVersions.toPromise);
  });
  DependencyWithModels.getAssemblyDependencyModels.use(function (_ref87) {
    var id = _ref87.id,
        version = _ref87.version;
    return setManagement.get("/v1/classifier-repo/assembly-classifier/".concat(id, "/version/").concat(version, "/dependency-models")).then(DependencyWithModels.getAssemblyDependencyModels.toPromise);
  });
  UserClassifierGroup.createFilter.use(function (_ref88) {
    var classifierId = _ref88.classifierId,
        classifierVersion = _ref88.classifierVersion,
        groupId = _ref88.groupId,
        filterCondition = _ref88.filterCondition;
    return setManagement.post("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/filter-group/").concat(groupId), {
      filterCondition: filterCondition
    }).then(UserClassifierGroup.createFilter.toPromise);
  });
  UserClassifierGroup.updateFilter.use(function (_ref89) {
    var classifierId = _ref89.classifierId,
        classifierVersion = _ref89.classifierVersion,
        groupId = _ref89.groupId,
        filterCondition = _ref89.filterCondition;
    return setManagement.put("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/filter-group/").concat(groupId), {
      filterCondition: filterCondition
    }).then(UserClassifierGroup.updateFilter.toPromise);
  });
  UserClassifierGroup.removeFilter.use(function (_ref90) {
    var classifierId = _ref90.classifierId,
        classifierVersion = _ref90.classifierVersion,
        groupId = _ref90.groupId;
    return setManagement["delete"]("/v1/classifier-repo/user-classifier/".concat(classifierId, "/version/").concat(classifierVersion, "/filter-group/").concat(groupId)).then(UserClassifierGroup.removeFilter.toPromise);
  });
}